import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ModalWorkspace from './ModalWorkspace';
import AlertModal from '../../../shared/components/Modal';

const ListWorkspacesActions = ({ data, refresh }) => {
    const history = useHistory();
    
    const [space,setSpace] = React.useState(data.data.original)
    const [openModal, setOpenModal] = React.useState(false);
    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const closeModalDelete = () => {
        setDeleteModal(false);
    }

    const deleteSpace = async () => {
        
    }

    return (<Fragment>
        <td role="cell">
            <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>

            {
                /*<IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>*/
            }

            <ModalWorkspace 
            openModal={openModal}
            closeModal={() => setOpenModal(false)}
            refresh={() => refresh()}
            dataSpace={space}            
            />
        </td>

        <AlertModal
            color="warning"
            title="Esta seguro de inhabilitar este espacio de trabajo?"
            modal={showDeleteModal}
            onOk={() => deleteSpace()}
            toggle={() => closeModalDelete()}
        />

        <AlertModal
            color="success"
            title="Espacio de Trabajo Inhabilitado Correctamente"
            modal={successModal}
            onOk={() => refresh()}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al Inhabilitar este espacio de Trabajo"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />

    </Fragment>)
}

export default ListWorkspacesActions;